'use client';
/*
 * Only needed until old location select goes away permanently
 */
import dynamic from 'next/dynamic';
import { useBooleanFlagValue } from '@openfeature/react-sdk';
import { IMapSearch } from '../or-mapping-tool.types';

// IMPORTANT: I don't know WHY this requires SSR pre-rendering but it does so don't flag SSR false on it for import
const MapSearchFuse = dynamic(() =>
  import('@/components/organisms/or-mapping-tool/search/map-search-fuse').then(
    (mod) => ({
      default: mod.MapSearchFuse,
    }),
  ),
);

const MapSearch = dynamic(
  () =>
    import('@/components/organisms/or-mapping-tool/search/map-search').then(
      (mod) => ({
        default: mod.MapSearch,
      }),
    ),
  { ssr: false },
);

export function MapSearchWrapper({
  onElementClick,
  locationData,
  onFocusChange,
}: Readonly<IMapSearch>) {
  // Use the "query-style" flag evaluation hook, specifying a flag-key and a default value.
  const showNewSearch = useBooleanFlagValue('radar', false, {
    suspendUntilReady: true,
    suspendWhileReconciling: true,
  });

  if (showNewSearch) {
    return (
      <MapSearch
        onElementClick={onElementClick}
        locationData={locationData}
        onFocusChange={onFocusChange}
      />
    );
  } else {
    return (
      <MapSearchFuse
        onElementClick={onElementClick}
        locationData={locationData}
        onFocusChange={onFocusChange}
      />
    );
  }
}
